/*<-----------------imports------------------------->*/
import React from "react";
import { Card } from "../company-card/company-card.component";
import "./company-card-list.css";
/*<-----------------imports------------------------->*/
export const CardList = (props) => {
  return (
    <div className="card-list">
      {props.companies.map((company) => (
        <Card key="company.id" company={company} />
      ))}
    </div>
  );
};
